import React from "react";
import type { BoxProps } from "@chakra-ui/react";
import { AccordionPanel, Box, Divider } from "@chakra-ui/react";
import type { IContentMenu } from "../../..";
import { observer } from "mobx-react-lite";
import { colors } from "../../../../../theme/colors";
import { useNavigateCustom } from "../../../../../hooks";

interface IMenuSubItemProps extends BoxProps {
	subMenu?: IContentMenu[];
	menuTitle: string;
	onTriggerTagging?(description: string, step?: string): void;
	setIsOpen?(isOpen: boolean): void;
}

const MenuSubItem: React.FC<IMenuSubItemProps> = observer(({ subMenu, menuTitle, onTriggerTagging, setIsOpen, ...rest }) => {
	const navigate = useNavigateCustom();

	const onClick = (link: string | undefined, label: string, newTab: boolean | undefined, external?: boolean): React.ReactElement | void => {
		onTriggerTagging!(label, menuTitle);
		if (link) {
			setIsOpen && setIsOpen(false);
			if (newTab || external) {
				window.open(link, newTab ? "_blank" : "_self");
				return;
			}
			return navigate(link);
		}
	};

	return (
		<Box bg={"white.550"} {...rest}>
			{subMenu?.map(({ link, label, newTab, external }) => (
				<>
					<AccordionPanel
						p={"24px 16px"}
						fontFamily="VivoType"
						fontWeight={500}
						display="flex"
						justifyContent="space-between"
						alignItems="center"
						onClick={() => onClick(link, label, newTab, external)}
						pointerEvents={"auto"}
						textColor={colors.black[500]}
					>
						{label}
					</AccordionPanel>
					<Box m={"0 16px"}>
						<Divider borderColor={"white.200"} opacity={1} />
					</Box>
				</>
			))}
		</Box>
	);
});

export default MenuSubItem;
